import React from 'react';
import { motion } from 'motion/react';

const PageTransition = ({ children, variant = 'slide' }) => {
    const variants = {
        slide: {
            initial: {
                opacity: 0,
                x: -20,
            },
            in: {
                opacity: 1,
                x: 0,
            },
            out: {
                opacity: 0,
                x: 20,
            },
        },
        fade: {
            initial: {
                opacity: 0,
            },
            in: {
                opacity: 1,
            },
            out: {
                opacity: 0,
            },
        },
        scale: {
            initial: {
                opacity: 0,
                scale: 0.95,
            },
            in: {
                opacity: 1,
                scale: 1,
            },
            out: {
                opacity: 0,
                scale: 1.05,
            },
        },
        slideUp: {
            initial: {
                opacity: 0,
                y: 20,
            },
            in: {
                opacity: 1,
                y: 0,
            },
            out: {
                opacity: 0,
                y: -20,
            },
        },
    };

    const transitions = {
        slide: {
            type: 'tween',
            ease: 'anticipate',
            duration: 0.4,
        },
        fade: {
            type: 'tween',
            ease: 'easeInOut',
            duration: 0.3,
        },
        scale: {
            type: 'spring',
            stiffness: 300,
            damping: 30,
        },
        slideUp: {
            type: 'tween',
            ease: 'easeOut',
            duration: 0.4,
        },
    };

    return (
        <motion.div
            initial="initial"
            animate="in"
            exit="out"
            variants={variants[variant]}
            transition={transitions[variant]}
        >
            {children}
        </motion.div>
    );
};

export default PageTransition;
